<mat-card class="settingsBody">
    <div class="settings-heading">Company Notifications</div>

    <p class="section-title">
        Manage which notifications your users can receive. Anything disabled here will be
        unavailable for users.
    </p>
    <br />
    <custom-mat-table
        [customTableInfo]="customTableInfo"
        (contentChanged)="contentChanged($event)"
        (inputChangeEvent)="inputChangeEvent($event)"
    ></custom-mat-table>
</mat-card>
